
import { Token } from '../../../../data/models/base/index';

export class TokenService {
    private static readonly TokenKey: string = 'token';

    public static setToken(token: Token) {
        localStorage.setItem(this.TokenKey, JSON.stringify(token));
    }

    public static getToken(): Token {
      let token = JSON.parse(localStorage.getItem(this.TokenKey));

      if (!token) {
          return new Token();
      }

      return token;
    }


    public static removeToken() {
        localStorage.removeItem(this.TokenKey);
    }
}



// WEBPACK FOOTER //
// ./src/app/infrastructure/services/base/security/token.service.ts